import familiadosApiClient from '$utils/familiadosApiClient'
import { apiErrorService } from '$utils/services/apiErrorService'
import { CaretakerDetailsDto } from '$domain/model/caretaker/caretakerDetails/caretakerDetails.model'
import { modelToCaretakerDetails } from '$domain/model/caretaker/caretakerDetails/caretakerDetails.mapper'

export const getCaretakerDetailsPath = caretakerId => `caretaker/details/${caretakerId}`

export const getCaretakerDetails = async caretakerId => {
  try {
    const caretakerData = await familiadosApiClient.get<CaretakerDetailsDto>(getCaretakerDetailsPath(caretakerId))
    return modelToCaretakerDetails(caretakerData)
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}



// WEBPACK FOOTER //
// ./src/domain/model/caretaker/caretakerDetails/caretakerDetails.manager.ts